import React from "react";
import "./style.css";

export function CustomSubHeader(props) {
  return (
    <>
      {/* <div id="pushdiv" style={{ display: "none" }}>
      </div> */}
      <div
        id="kt_subheader"
        className={`header1 header-fixed px-5`}
        style={{
          borderBottom: "1px solid rgb(220, 221, 221)",
          borderTop: "1px solid rgb(82 63 105 / 8%)",
          backgroundColor: "rgba(255,255,255,1)",
          height: 55,
          marginBottom: 15,
          zIndex: props.highIndex ? 2 : 2,
          display: "flex",
          alignItems: "center",
        }}
      >
        {props.children}
      </div>
    </>
  );
}
